import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
const CITY_FIELDS = `{
    "city": { "geoname_id": 5375480, "names": { "en": "Mountain View" } },
    "location": {
      "accuracy_radius": 1000,
      "average_income": null,
      "latitude": 37.386,
      "longitude": -122.0838,
      "metro_code": 807,
      "population_density": null,
      "time_zone": "America/Los_Angeles"
    },
    "postal": { "code": "94035" },
    "subdivisions": [ { "geoname_id": 5332921, "iso_code": "CA", "names": { "en": "California" } } ],
}`;
const COUNTRY_FIELDS = `{
    "continent": { "code": "NA", "geoname_id": 6255149, "names": { "en": "North America" } },
    "country": { "geoname_id": 6252001, "iso_code": "US", "names": { "en": "United States" } },
    "registered_country": { "geoname_id": 6252001, "iso_code": "US", "names": { } },
    "represented_country": { "geoname_id": null, "iso_code": "US", "names": { } },
    "traits": {
      "ip_address": "8.8.8.8",
      "is_anonymous_proxy": false,
      "is_legitimate_proxy": false,
      "is_satellite_provider": false,
      "isp": null,
      "organization": null,
    }
}`;
const ASN_FIELDS = `{
    "as_number": 15169,
    "as_organization": "Google LLC"
}`;
const MaxmindAdapterDocumentation = () => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", null, t("maxmind_adapter.documentation.intro")), /* @__PURE__ */ React.createElement(Alert, { style: { marginBottom: 10 }, bsStyle: "info", title: t("maxmind_adapter.documentation.limitations_title") }, /* @__PURE__ */ React.createElement("p", null, t("maxmind_adapter.documentation.limitations_supported")), /* @__PURE__ */ React.createElement("p", null, t("maxmind_adapter.documentation.limitations_more"))), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("h3", { style: { marginBottom: 10 } }, t("maxmind_adapter.documentation.asn_fields")), /* @__PURE__ */ React.createElement("pre", null, ASN_FIELDS), /* @__PURE__ */ React.createElement("h3", { style: { marginBottom: 10 } }, t("maxmind_adapter.documentation.country_fields")), /* @__PURE__ */ React.createElement("pre", null, COUNTRY_FIELDS), /* @__PURE__ */ React.createElement("h3", { style: { marginBottom: 10 } }, t("maxmind_adapter.documentation.city_fields")), /* @__PURE__ */ React.createElement("p", null, t("maxmind_adapter.documentation.city_additional_fields")), /* @__PURE__ */ React.createElement("pre", null, CITY_FIELDS), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "maxmind_adapter.documentation.complete_documentation",
      components: {
        docsLink: /* @__PURE__ */ React.createElement("a", { href: "http://maxmind.github.io/GeoIP2-java/", target: "_blank", rel: "noopener noreferrer" })
      }
    }
  )));
};
export default MaxmindAdapterDocumentation;
